export type ProductStatus = 'available' | 'alpha' | 'coming_soon';
export type RoadmapProductStatus = Exclude<ProductStatus, 'available'>;
export type ProductCode =
  | 'finance_core'
  | 'crm'
  | 'sales_proformas'
  | 'investments'
  | 'dataroom'
  | 'project_reporting'
  | 'public_portal';

export interface CommercialProduct {
  code: ProductCode;
  status: ProductStatus;
  nameKey: string;
  descriptionKey: string;
  valueKey: string;
  // Only for roadmap products with a committed quarter that has not passed.
  // Without it the modules page shows "Por confirmar".
  availabilityDate?: string;
  // Public site of a product that is sold under its own brand.
  siteUrl?: string;
}

export interface RoadmapProduct extends CommercialProduct {
  status: RoadmapProductStatus;
}

export const commercialProducts: CommercialProduct[] = [
  {
    code: 'finance_core',
    status: 'available',
    nameKey: 'modules:modules.finance_core.name',
    descriptionKey: 'modules:modules.finance_core.description',
    valueKey: 'modules:modules.finance_core.value',
  },
  {
    code: 'crm',
    status: 'available',
    nameKey: 'modules:modules.crm.name',
    descriptionKey: 'modules:modules.crm.description',
    valueKey: 'modules:modules.crm.value',
  },
  {
    code: 'sales_proformas',
    status: 'available',
    nameKey: 'modules:modules.sales_proformas.name',
    descriptionKey: 'modules:modules.sales_proformas.description',
    valueKey: 'modules:modules.sales_proformas.value',
  },
  {
    code: 'investments',
    // Built and deployed, but without customers or a general release.
    status: 'alpha',
    nameKey: 'modules:modules.investments.name',
    descriptionKey: 'modules:modules.investments.description',
    valueKey: 'modules:modules.investments.value',
  },
  {
    code: 'dataroom',
    // Sala de Datos is a standalone product. It runs in production without
    // customers or a general release.
    status: 'alpha',
    nameKey: 'modules:modules.dataroom.name',
    descriptionKey: 'modules:modules.dataroom.description',
    valueKey: 'modules:modules.dataroom.value',
    siteUrl: 'https://saladedatos.com/',
  },
  {
    code: 'project_reporting',
    status: 'coming_soon',
    nameKey: 'modules:modules.project_reporting.name',
    descriptionKey: 'modules:modules.project_reporting.description',
    valueKey: 'modules:modules.project_reporting.value',
    availabilityDate: 'Q4 2026',
  },
  {
    code: 'public_portal',
    status: 'available',
    nameKey: 'modules:modules.public_portal.name',
    descriptionKey: 'modules:modules.public_portal.description',
    valueKey: 'modules:modules.public_portal.value',
  },
];

export function getAvailableProducts(): CommercialProduct[] {
  return commercialProducts.filter((product) => product.status === 'available');
}

export function getRoadmapProducts(): RoadmapProduct[] {
  return commercialProducts.filter(
    (product): product is RoadmapProduct => product.status !== 'available'
  );
}
